import React from "react";

const BotIcon: React.FC = () => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="22" cy="22" r="22" fill="#2F422C" />
      <g clipPath="url(#clip0_4548_1927)">
        <path
          d="M29.6154 13.75H14.3846C13.487 13.75 12.6261 14.1066 11.9913 14.7413C11.3566 15.3761 11 16.237 11 17.1346V25.5962C11 26.4938 11.3566 27.3547 11.9913 27.9894C12.6261 28.6242 13.487 28.9808 14.3846 28.9808H23.6923L28.7692 32.3654V28.9808H29.6154C30.513 28.9808 31.3739 28.6242 32.0087 27.9894C32.6434 27.3547 33 26.4938 33 25.5962V17.1346C33 16.237 32.6434 15.3761 32.0087 14.7413C31.3739 14.1066 30.513 13.75 29.6154 13.75Z"
          fill="white"
        />
        <path
          d="M17.7841 21.365C17.7841 21.5894 17.695 21.8046 17.5363 21.9633C17.3776 22.122 17.1624 22.2112 16.938 22.2112C16.7135 22.2112 16.4983 22.122 16.3396 21.9633C16.1809 21.8046 16.0918 21.5894 16.0918 21.365C16.0918 21.1406 16.1809 20.9254 16.3396 20.7667C16.4983 20.608 16.7135 20.5189 16.938 20.5189C17.1624 20.5189 17.3776 20.608 17.5363 20.7667C17.695 20.9254 17.7841 21.1406 17.7841 21.365ZM22.861 21.365C22.861 21.5894 22.7719 21.8046 22.6132 21.9633C22.4545 22.122 22.2393 22.2112 22.0149 22.2112C21.7905 22.2112 21.5752 22.122 21.4166 21.9633C21.2579 21.8046 21.1687 21.5894 21.1687 21.365C21.1687 21.1406 21.2579 20.9254 21.4166 20.7667C21.5752 20.608 21.7905 20.5189 22.0149 20.5189C22.2393 20.5189 22.4545 20.608 22.6132 20.7667C22.7719 20.9254 22.861 21.1406 22.861 21.365ZM27.938 21.365C27.938 21.5894 27.8488 21.8046 27.6901 21.9633C27.5314 22.122 27.3162 22.2112 27.0918 22.2112C26.8674 22.2112 26.6522 22.122 26.4935 21.9633C26.3348 21.8046 26.2456 21.5894 26.2456 21.365C26.2456 21.1406 26.3348 20.9254 26.4935 20.7667C26.6522 20.608 26.8674 20.5189 27.0918 20.5189C27.3162 20.5189 27.5314 20.608 27.6901 20.7667C27.8488 20.9254 27.938 21.1406 27.938 21.365Z"
          stroke="#2F422C"
          strokeWidth="1.69231"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4548_1927">
          <rect
            width="22"
            height="22"
            fill="white"
            transform="translate(11 11)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BotIcon;
